import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "sheesh_admin_token";
const EMP_TOKEN_KEY = "sheesh_employee_token";
const EMP_KEY = "sheesh_employee_info";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(t) {
  localStorage.setItem(TOKEN_KEY, t);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function getEmployeeToken() {
  return localStorage.getItem(EMP_TOKEN_KEY);
}

export function setEmployeeToken(t) {
  localStorage.setItem(EMP_TOKEN_KEY, t);
}

export function clearEmployeeToken() {
  localStorage.removeItem(EMP_TOKEN_KEY);
  localStorage.removeItem(EMP_KEY);
}

export function getEmployee() {
  try { return JSON.parse(localStorage.getItem(EMP_KEY) || "null"); } catch { return null; }
}

export function setEmployee(info) {
  localStorage.setItem(EMP_KEY, JSON.stringify(info));
}

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (!window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

// Public (customer) calls — no auth header
export const publicApi = axios.create({ baseURL: API });

// Employee-authenticated calls
export const empApi = axios.create({ baseURL: API });
empApi.interceptors.request.use((config) => {
  const t = getEmployeeToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
empApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearEmployeeToken();
      if (!window.location.pathname.startsWith("/employee/login")) {
        window.location.href = "/employee/login";
      }
    }
    return Promise.reject(err);
  }
);

